var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { always } from "asrt";
import { isInstanceOf } from "@pzapalski/ts-utils/dist/guards/is-instance-of";
import { t } from "../functions/t";
export function productListController(container) {
    always(isInstanceOf(HTMLElement, container), "[ddM-JVE-c7u]");
    // if js loaded, we hide pagination links
    const paginationElements = document.querySelectorAll('[data-element="Pagination"]');
    paginationElements.forEach(pe => {
        pe.classList.add('hidden');
    });
    /**
     * infinite scroll
     * */
    // prepare spinner element
    const spinner = document.createElement('div');
    spinner.classList.add('mip-loadingIndicator__wrapper');
    spinner.setAttribute('style', `flex-basis: 100%; text-align: center;`);
    spinner.innerHTML = `
    <span class="mip-loadingIndicator mip-loadingIndicator--dark mip-loadingIndicator--big" style="margin-left: auto; margin-right: auto;">
        <span class="sr-only">${t('ui.loading')}</span>
    </span>
  `;
    container.appendChild(spinner);
    // check if the bottom of the viewport is at or below the bottom edge of the container
    // if we are, load more items from the server
    // if we are not, do nothing
    // if the server sends an empty array, then we are done
    let loading = false;
    let currentPage = 1;
    let noMoreItems = false;
    window.addEventListener('scroll', () => __awaiter(this, void 0, void 0, function* () {
        const scrollBottom = window.innerHeight + window.scrollY;
        const containerBottom = container.getBoundingClientRect().bottom;
        const bottomedOut = scrollBottom >= containerBottom;
        if (bottomedOut === true
            && loading === false
            && noMoreItems === false) {
            loading = true;
            spinner.classList.add('loading');
            const query = new URLSearchParams(window.location.search);
            query.set('page', (currentPage + 1).toString(10));
            console.log(query.toString());
            const response = yield fetch(`/api/v1/fragment/products?${query.toString()}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'text/html',
                }
            });
            loading = false;
            spinner.classList.remove('loading');
            if (response.ok === false) {
                return;
            }
            if (response.status === 204) {
                noMoreItems = true;
                return;
            }
            const markup = yield response.text();
            const fragment = document.createRange().createContextualFragment(markup);
            container.insertBefore(fragment, spinner);
            currentPage += 1;
        }
    }));
}
